import { type CourtEvent } from "../types/types";

export const CourtEventsMockData: CourtEvent[] = [
  {
    date: "2024-04-25",
    title: "Abacus v Clover | Claimant, Defendant | Preliminary hearing for solicitors, 9am",
    documentRef: "Demo_Court_Order_v1_1",
    details:
      "Demo Court Order: UPON HEARING the solicitors for the Claimant and the Defendant at a preliminary hearing on 25 April 2024; Summary: Summary for demo court order",
    party: "Claimant",
    documentLink: "https://www.example.com",
  },
  {
    date: "2024-05-01",
    title: "Abacus v Clover | Defendant | Hearing scheduled for 1 May 2025",
    documentRef: "Demo_Court_Order_v1_1",
    details: "Demo Court Order: HEARING DATE: 1 May 2024; Summary: Summary for demo court order",
    party: "Defendant",
    documentLink: "https://www.example.com",
  },
  {
    date: "2024-05-01",
    title: "Abacus v Clover | All Parties | Issued this day, May 1st",
    documentRef: "Demo_Court_Order_v1_1",
    details: "Demo Court Order: Issued this 1st day of May 2024; Summary: Summary for demo court order",
    party: "All Parties",
    documentLink: "https://www.example.com",
  },
  {
    date: "2025-05-01",
    title: "Abacus v Clover | All Parties | Hearing scheduled for May 1st",
    documentRef: "Demo_Court_Order_v1_1",
    details: "Demo Court Order: HEARING DATE: 1 May 2025; Summary: Summary for demo court order",
    party: "All Parties",
    documentLink: "https://www.example.com",
  },
  {
    date: "2025-05-01",
    title: "Abacus v Clover | Claimant, Defendant | Preliminary hearing follow-up, 25 April",
    documentRef: "Demo_Court_Order_v1_1",
    details:
      "Demo Court Order: UPON HEARING the solicitors for the Claimant and the Defendant at a preliminary hearing on 25 April 2025; Summary: Summary for demo court order",
    party: "Claimant",
    documentLink: "https://www.example.com",
  },
  {
    date: "2025-05-01",
    title: "Abacus v Clover | Defendant | Issued this 1st May 2025",
    documentRef: "Demo_Court_Order_v1_1",
    details: "Demo Court Order: Issued this 1st day of May 2025; Summary: Summary for demo court order",
    party: "Defendant",
    documentLink: "https://www.example.com",
  },
  {
    date: "2025-09-02",
    title: "Abacus v Clover | Claimant | Disclose rental comparison matrix by 4pm",
    documentRef: "Demo_Court_Order_v1_1",
    details:
      "Demo Court Order: The Claimant shall disclose copies of the rental comparison matrix by 4pm on 2 September 2025; Summary: Summary for demo court order",
    party: "Claimant",
    documentLink: "https://www.example.com",
  },
  {
    date: "2025-10-15",
    title: "Abacus v Clover | All Parties | Submit expert reports by 4pm",
    documentRef: "Demo_Court_Order_v1_1",
    details:
      "Demo Court Order: The Parties are directed to submit expert reports by 4pm on 15 October 2025; Summary: Summary for demo court order",
    party: "All Parties",
    documentLink: "https://www.example.com",
  },
  {
    date: "2025-10-31",
    title: "Abacus v Clover | All Parties | File reply to expert reports",
    documentRef: "Demo_Court_Order_v1_1",
    details:
      "Demo Court Order: The Parties are to file any reply to expert reports by 31 October 2025; Summary: Summary for demo court order",
    party: "All Parties",
    documentLink: "https://www.example.com",
  },
  {
    date: "2025-11-01",
    title: "Abacus v Clover | Claimant | Request service quotation by 4pm",
    documentRef: "Demo_Court_Order_v1_1",
    details:
      "Demo Court Order: The Claimant must by 4:00pm on 1 November 2025 request XYZ Intermediary Services to provide a quotation for the supply of services including necessary preparative work for the ground rules hearing and final hearing; Summary: Summary for demo court order",
    party: "Claimant",
    documentLink: "https://www.example.com",
  },
  {
    date: "2025-11-07",
    title: "Abacus v Clover | All Parties | Pre-trial review, set timetable 9am",
    documentRef: "Demo_Court_Order_v1_1",
    details:
      "Demo Court Order: A pre-trial review is scheduled for 7 November 2025, at which the court will consider any final issues before trial and set the trial timetable; Summary: Summary for demo court order",
    party: "All Parties",
    documentLink: "https://www.example.com",
  },
  {
    date: "2025-11-16",
    title: "Abacus v Clover | Claimant | Send quotation to HMCTS by 16th",
    documentRef: "Demo_Court_Order_v1_1",
    details:
      "Demo Court Order: The quotation must be sent by the Claimant to HMCTS for the attention of the court manager by 16 November 2025; Summary: Summary for demo court order",
    party: "Claimant",
    documentLink: "https://www.example.com",
  },
];

export const VerifyTableData: CourtEvent[] = [
  {
    date: "2025-04-25",
    title: "Abacus v Clover | Claimant, Defendant | Preliminary hearing for solicitors, 9am",
    documentRef: "Demo_Court_Order_v1_1",
    details:
      "Demo Court Order: UPON HEARING the solicitors for the Claimant and the Defendant at a preliminary hearing on 25 April 2025; Summary: Summary for demo court order",
    party: "Claimant",
    documentLink: "https://www.example.com",
  },
  {
    date: "2025-05-01",
    title: "Abacus v Clover | Defendant | Hearing scheduled for 1 May 2025",
    documentRef: "Demo_Court_Order_v1_1",
    details: "Demo Court Order: HEARING DATE: 1 May 2025; Summary: Summary for demo court order",
    party: "Defendant",
    documentLink: "https://www.example.com",
  },
  {
    date: "2025-05-01",
    title: "Abacus v Clover | All Parties | Issued this day, May 1st",
    documentRef: "Demo_Court_Order_v1_1",
    details: "Demo Court Order: Issued this 1st day of May 2025; Summary: Summary for demo court order",
    party: "All Parties",
    documentLink: "https://www.example.com",
  },
  {
    date: "2025-05-01",
    title: "Abacus v Clover | All Parties | Hearing scheduled for May 1st",
    documentRef: "Demo_Court_Order_v1_1",
    details: "Demo Court Order: HEARING DATE: 1 May 2025; Summary: Summary for demo court order",
    party: "All Parties",
    documentLink: "https://www.example.com",
  },
  {
    date: "2025-05-01",
    title: "Abacus v Clover | Claimant, Defendant | Preliminary hearing follow-up, 25 April",
    documentRef: "Demo_Court_Order_v1_1",
    details:
      "Demo Court Order: UPON HEARING the solicitors for the Claimant and the Defendant at a preliminary hearing on 25 April 2025; Summary: Summary for demo court order",
    party: "Claimant",
    documentLink: "https://www.example.com",
  },
  {
    date: "2025-05-01",
    title: "Abacus v Clover | Defendant | Issued this 1st May 2025",
    documentRef: "Demo_Court_Order_v1_1",
    details: "Demo Court Order: Issued this 1st day of May 2025; Summary: Summary for demo court order",
    party: "Defendant",
    documentLink: "https://www.example.com",
  },
  {
    date: "2025-09-02",
    title: "Abacus v Clover | Claimant | Disclose rental comparison matrix by 4pm",
    documentRef: "Demo_Court_Order_v1_1",
    details:
      "Demo Court Order: The Claimant shall disclose copies of the rental comparison matrix by 4pm on 2 September 2025; Summary: Summary for demo court order",
    party: "Claimant",
    documentLink: "https://www.example.com",
  },
  {
    date: "2025-10-15",
    title: "Abacus v Clover | All Parties | Submit expert reports by 4pm",
    documentRef: "Demo_Court_Order_v1_1",
    details:
      "Demo Court Order: The Parties are directed to submit expert reports by 4pm on 15 October 2025; Summary: Summary for demo court order",
    party: "All Parties",
    documentLink: "https://www.example.com",
  },
  {
    date: "2025-10-31",
    title: "Abacus v Clover | All Parties | File reply to expert reports",
    documentRef: "Demo_Court_Order_v1_1",
    details:
      "Demo Court Order: The Parties are to file any reply to expert reports by 31 October 2025; Summary: Summary for demo court order",
    party: "All Parties",
    documentLink: "https://www.example.com",
  },
  {
    date: "2025-11-01",
    title: "Abacus v Clover | Claimant | Request service quotation by 4pm",
    documentRef: "Demo_Court_Order_v1_1",
    details:
      "Demo Court Order: The Claimant must by 4:00pm on 1 November 2025 request XYZ Intermediary Services to provide a quotation for the supply of services including necessary preparative work for the ground rules hearing and final hearing; Summary: Summary for demo court order",
    party: "Claimant",
    documentLink: "https://www.example.com",
  },
  {
    date: "2025-11-07",
    title: "Abacus v Clover | All Parties | Pre-trial review, set timetable 9am",
    documentRef: "Demo_Court_Order_v1_1",
    details:
      "Demo Court Order: A pre-trial review is scheduled for 7 November 2025, at which the court will consider any final issues before trial and set the trial timetable; Summary: Summary for demo court order",
    party: "All Parties",
    documentLink: "https://www.example.com",
  },
  {
    date: "2025-11-16",
    title: "Abacus v Clover | Claimant | Send quotation to HMCTS by 16th",
    documentRef: "Demo_Court_Order_v1_1",
    details:
      "Demo Court Order: The quotation must be sent by the Claimant to HMCTS for the attention of the court manager by 16 November 2025; Summary: Summary for demo court order",
    party: "Claimant",
    documentLink: "https://www.example.com",
  },
];

export type HighlightArea = {
  pageIndex: number;
  height: number;
  width: number;
  left: number;
  top: number;
};

export type Cite = {
  text: string;
  page: number;
  highlightText: string;
  highlightAreas: Array<HighlightArea>;
};

export type Summary = {
  text: string;
  cites: Array<Cite>;
};

export type CourtDataItem = {
  id: string;
  date: string;
  party: "Claimant" | "Defendant" | "All Parties" | "Appellant";
  title: string;
  documentRef: string;
  documentLink: string;
  details: string;
  missingDay: boolean;
  pageNumber: number;
  futureDate: boolean;
  target: string;
  summary: Array<Summary>;
  action: boolean;
  noYear: boolean;
  duplicates: boolean;
  check: boolean;
  verificationScore: number;
};

export const courtDataUpdatedMock: Array<CourtDataItem> = [
  {
    date: "2024-08-25",
    party: "All Parties",
    title: "Abacus v Clover | Claimant, Defendant | Preliminary hearing for solicitors, 9am",
    documentRef: "Vicky_Demo_Court_Order_v1_1",
    documentLink: "https://www.example.com",
    details:
      "1UPON HEARING the solicitors for the Claimant and the Defendant at a preliminary hearing on 25 August 2024;",
    missingDay: false,
    pageNumber: 1,
    futureDate: false,
    target: "Claimant",
    summary: [
      {
        text: "Abacus v Clover | Claimant, Defendant | Preliminary hearing for solicitors, 9am",
        cites: [
          {
            text: "UPON HEARING the solicitors for the Claimant and the Defendant at a preliminary hearing on 25 August 2024;",
            page: 2,
            highlightText: "final",
            highlightAreas: [
              {
                pageIndex: 1,
                height: 5.0,
                width: 78.0,
                left: 10.0,
                top: 10.0,
              },
            ],
          },
        ],
      },
    ],
    action: false,
    noYear: false,
    duplicates: false,
    check: false,
    verificationScore: 30,
    id: "event1",
  },
  {
    date: "2024-09-01",
    party: "All Parties",
    title: "Abacus v Clover | All Parties | Hearing scheduled for 1 September 2024",
    documentRef: "Vicky_Demo_Court_Order_v1_1",
    documentLink: "https://www.example.com",
    details: "HEARING DATE: 1 May 2025",
    missingDay: false,
    pageNumber: 1,
    futureDate: false,
    target: "Appellant",
    summary: [
      {
        text: "Abacus v Clover | All Parties | Hearing scheduled for 1 September 2024",
        cites: [
          {
            text: "HEARING DATE: 1 September 2024",
            page: 1,
            highlightText: "final",
            highlightAreas: [
              {
                pageIndex: 0,
                height: 10.0,
                width: 78.0,
                left: 10.0,
                top: 80.0,
              },
            ],
          },
        ],
      },
    ],
    action: false,
    noYear: false,
    duplicates: true,
    check: true,
    verificationScore: 40,
    id: "event2",
  },
  {
    date: "",
    party: "Claimant",
    title: "Abacus v Clover | Claimant | Issued this day, September 1st",
    documentRef: "Vicky_Demo_Court_Order_v1_1",
    documentLink: "https://www.example.com",
    details:
      "HMCTS must confirm acceptance of the quotation and payment of intermediary services within 7 days after receipt of the quotation",
    missingDay: true,
    pageNumber: 2,
    futureDate: false,
    target: "Appellant",
    summary: [
      {
        text: "Abacus v Clover | All Parties | Issued this day, September 1st",
        cites: [
          {
            text: "HMCTS must confirm acceptance of the quotation and payment of intermediary services within 7 days after receipt of the quotation.",
            page: 2,
            highlightText: "final",
            highlightAreas: [
              {
                pageIndex: 1,
                height: 8.0,
                width: 78.0,
                left: 10.0,
                top: 73.0,
              },
            ],
          },
        ],
      },
    ],
    action: false,
    noYear: false,
    duplicates: true,
    check: true,
    verificationScore: 30,
    id: "event3",
  },

  {
    date: "2025-09-02",
    party: "Claimant",
    title: 'Abacus v Clover | Claimant | "Disclose rental comparison matrix 4pm"',
    documentRef: "Vicky_Demo_Court_Order_v1_1",
    documentLink: "https://www.example.com",
    details: "The Claimant shall disclose copies of the rental comparison matrix by 4pm on 2 September 2025",
    missingDay: false,
    pageNumber: 2,
    futureDate: true,
    target: "Appellant",
    summary: [
      {
        text: 'Abacus v Clover | Claimant | "Disclose rental comparison matrix 4pm"',
        cites: [
          {
            text: "The Claimant shall disclose copies of the rental comparison matrix by 4pm on 2 September 2025",
            page: 2,
            highlightText: "final",
            highlightAreas: [
              {
                pageIndex: 1,
                height: 5.0,
                width: 78.0,
                left: 10.0,
                top: 30.0,
              },
            ],
          },
        ],
      },
    ],
    action: true,
    noYear: false,
    duplicates: false,
    check: false,
    verificationScore: 100,
    id: "event7",
  },
  {
    date: "2025-09-05",
    party: "All Parties",
    title: "Abacus v Clover | All Parties | Disclose relevant documents by 4pm",
    documentRef: "Vicky_Demo_Court_Order_v1_1",
    documentLink: "https://www.example.com",
    details: "The Parties shall disclose all relevant documents by 4pm on 5 September 2025.",
    missingDay: false,
    pageNumber: 2,
    futureDate: true,
    target: "Appellant",
    summary: [
      {
        text: "Abacus v Clover | All Parties | Disclose relevant documents by 4pm",
        cites: [
          {
            text: "The Parties shall disclose all relevant documents by 4pm on 5 September 2025.",
            page: 2,
            highlightText: "final",
            highlightAreas: [
              {
                pageIndex: 1,
                height: 4.0,
                width: 78.0,
                left: 10.0,
                top: 33.5,
              },
            ],
          },
        ],
      },
    ],
    action: true,
    noYear: false,
    duplicates: false,
    check: false,
    verificationScore: 100,
    id: "event8",
  },
  {
    date: "2025-09-29",
    party: "All Parties",
    title: "Abacus v Clover | All Parties | Exchange witness statements by 4pm",
    documentRef: "Vicky_Demo_Court_Order_v1_1",
    documentLink: "https://www.example.com",
    details: "Signed witness statements are to be exchanged by the parties by 4pm on 29 September 2025.",
    missingDay: false,
    pageNumber: 2,
    futureDate: true,
    target: "Appellant",
    summary: [
      {
        text: "Abacus v Clover | All Parties | Exchange witness statements by 4pm",
        cites: [
          {
            text: "Signed witness statements are to be exchanged by the parties by 4pm on 29 September 2025.",
            page: 2,
            highlightText: "final",
            highlightAreas: [
              {
                pageIndex: 1,
                height: 4.0,
                width: 78.0,
                left: 10.0,
                top: 41.5,
              },
            ],
          },
        ],
      },
    ],
    action: true,
    noYear: false,
    duplicates: false,
    check: false,
    verificationScore: 100,
    id: "event9",
  },
  {
    date: "2025-10-01",
    party: "All Parties",
    title: "Abacus v Clover | All Parties | Ground rules hearing at 10am",
    documentRef: "Vicky_Demo_Court_Order_v1_1",
    documentLink: "https://www.example.com",
    details:
      "The case will be listed for a ground rules hearing at 10:00 am on 1 October 2025, allowing an estimated 2 hours.",
    missingDay: false,
    pageNumber: 2,
    futureDate: true,
    target: "Appellant",
    summary: [
      {
        text: "Abacus v Clover | All Parties | Ground rules hearing at 10am",
        cites: [
          {
            text: "The case will be listed for a ground rules hearing at 10:00 am on 1 October 2025, allowing an estimated 2 hours.",
            page: 2,
            highlightText: "final",
            highlightAreas: [
              {
                pageIndex: 1,
                height: 8.0,
                width: 78.0,
                left: 10.0,
                top: 81.5,
              },
            ],
          },
        ],
      },
    ],
    action: false,
    noYear: false,
    duplicates: false,
    check: false,
    verificationScore: 100,
    id: "event10",
  },
  {
    date: "2025-10-14",
    party: "Defendant",
    title: "Abacus v Clover | Defendant | Defendant's expert name disclosure deadline",
    documentRef: "Vicky_Demo_Court_Order_v1_1",
    documentLink: "https://www.example.com",
    details: "The Defendant will inform the Claimant of the name of their expert by 14 October 2025",
    missingDay: false,
    pageNumber: 2,
    futureDate: true,
    target: "Appellant",
    summary: [
      {
        text: "Abacus v Clover | Defendant | Defendant's expert name disclosure deadline",
        cites: [
          {
            text: "The Defendant will inform the Claimant of the name of their expert by 14 October 2025",
            page: 2,
            highlightText: "final",
            highlightAreas: [
              {
                pageIndex: 1,
                height: 3.0,
                width: 75.0,
                left: 10.0,
                top: 51.0,
              },
            ],
          },
        ],
      },
    ],
    action: true,
    noYear: false,
    duplicates: false,
    check: false,
    verificationScore: 100,
    id: "event11",
  },
  {
    date: "2025-10-15",
    party: "All Parties",
    title: "Abacus v Clover | All Parties | Submit expert reports by 4pm",
    documentRef: "Vicky_Demo_Court_Order_v1_1",
    documentLink: "https://www.example.com",
    details: "The Parties are directed to submit expert reports by 4pm on 15 October 2025.",
    missingDay: false,
    pageNumber: 2,
    futureDate: true,
    target: "Appellant",
    summary: [
      {
        text: "Abacus v Clover | All Parties | Submit expert reports by 4pm",
        cites: [
          {
            text: "The Parties are directed to submit expert reports by 4pm on 15 October 2025.",
            page: 2,
            highlightText: "final",
            highlightAreas: [
              {
                pageIndex: 1,
                height: 3.0,
                width: 75.0,
                left: 10.0,
                top: 53.5,
              },
            ],
          },
        ],
      },
    ],
    action: true,
    noYear: false,
    duplicates: false,
    check: false,
    verificationScore: 100,
    id: "event12",
  },
  {
    date: "2025-10-31",
    party: "All Parties",
    title: "Abacus v Clover | All Parties | File reply to expert reports",
    documentRef: "Vicky_Demo_Court_Order_v1_1",
    documentLink: "https://www.example.com",
    details: "The Parties are to file any reply to expert reports by 31 October 2025.",
    missingDay: false,
    pageNumber: 2,
    futureDate: true,
    target: "Appellant",
    summary: [
      {
        text: "Abacus v Clover | All Parties | File reply to expert reports",
        cites: [
          {
            text: "The Parties are to file any reply to expert reports by 31 October 2025.",
            page: 2,
            highlightText: "final",
            highlightAreas: [
              {
                pageIndex: 1,
                height: 3.0,
                width: 75.0,
                left: 10.0,
                top: 56.5,
              },
            ],
          },
        ],
      },
    ],
    action: true,
    noYear: false,
    duplicates: false,
    check: false,
    verificationScore: 100,
    id: "event13",
  },
  {
    date: "2025-11-01",
    party: "Claimant",
    title: "Abacus v Clover | Claimant | Request service quotation by 4pm",
    documentRef: "Vicky_Demo_Court_Order_v1_1",
    documentLink: "https://www.example.com",
    details:
      "The Claimant must by 4:00pm on 1 November 2025 request XYZ Intermediary Services to provide a quotation for the supply of services including necessary preparative work for the ground rules hearing and final hearing.",
    missingDay: false,
    pageNumber: 2,
    futureDate: true,
    target: "Appellant",
    summary: [
      {
        text: "Abacus v Clover | Claimant | Request service quotation by 4pm",
        cites: [
          {
            text: "The Claimant must by 4:00pm on 1 November 2025 request XYZ Intermediary Services to provide a quotation for the supply of services including necessary preparative work for the ground rules hearing and final hearing.",
            page: 2,
            highlightText: "final",
            highlightAreas: [
              {
                pageIndex: 1,
                height: 5.0,
                width: 75.0,
                left: 10.0,
                top: 62.5,
              },
            ],
          },
        ],
      },
    ],
    action: true,
    noYear: false,
    duplicates: false,
    check: false,
    verificationScore: 100,
    id: "event14",
  },
  {
    date: "2025-11-07",
    party: "All Parties",
    title: "Abacus v Clover | All Parties | Pre-trial review, set timetable 9am",
    documentRef: "Vicky_Demo_Court_Order_v1_1",
    documentLink: "https://www.example.com",
    details:
      "A pre-trial review is scheduled for 7 November 2025, at which the court will consider any final issues before trial and set the trial timetable.",
    missingDay: false,
    pageNumber: 2,
    futureDate: true,
    target: "Appellant",
    summary: [
      {
        text: "Abacus v Clover | All Parties | Pre-trial review, set timetable 9am",
        cites: [
          {
            text: "A pre-trial review is scheduled for 7 November 2025, at which the court will consider any final issues before trial and set the trial timetable.",
            page: 3,
            highlightText: "final",
            highlightAreas: [
              {
                pageIndex: 2,
                height: 4.0,
                width: 75.0,
                left: 10.0,
                top: 16.5,
              },
            ],
          },
        ],
      },
    ],
    action: true,
    noYear: false,
    duplicates: false,
    check: false,
    verificationScore: 100,
    id: "event15",
  },
  {
    date: "2025-11-16",
    party: "Claimant",
    title: "Abacus v Clover | Claimant | Send quotation to HMCTS by 16th",
    documentRef: "Vicky_Demo_Court_Order_v1_1",
    documentLink: "https://www.example.com",
    details:
      "The quotation must be sent by the Claimant to HMCTS for the attention of the court manager by 16 November 2025.",
    missingDay: false,
    pageNumber: 2,
    futureDate: true,
    target: "Appellant",
    summary: [
      {
        text: "Abacus v Clover | Claimant | Send quotation to HMCTS by 16th",
        cites: [
          {
            text: "The quotation must be sent by the Claimant to HMCTS for the attention of the court manager by 16 November 2025.",
            page: 2,
            highlightText: "final",
            highlightAreas: [
              {
                pageIndex: 1,
                height: 4.0,
                width: 75.0,
                left: 10.0,
                top: 70.5,
              },
            ],
          },
        ],
      },
    ],
    action: true,
    noYear: false,
    duplicates: false,
    check: false,
    verificationScore: 100,
    id: "event16",
  },
];
